var map_cfg_CA = {
    "mapWidth": "100%",
    "mapHeight": 435,
    
    "shadowAllow": false,
    "shadowWidth": 2,
    "shadowOpacity": 0.2,
    "shadowColor": "black",
    "shadowX": 0,
    "shadowY": 0,
    
    "iPhoneLink": true,
    "isNewWindow": false,
    
    "zoomEnable": true,
    "zoomEnableControls": true,
    "zoomIgnoreMouseScroll": true,
    "zoomMax": 8,
    "zoomStep": 0.4,
    
    "borderColor": "#ffffff",
    "borderColorOver": "#ffffff",
    "borderOpacity": 0.5,
    
    "nameColor": "#ffffff",

"nameFontFamily": 'MyriadPro-SemiCn-5',

    "nameColorOver": "#ffffff",
    "nameFontSize": "12px",
    "nameFontWeight": "normal",
    
    "nameStroke": false,
    "nameStrokeColor": "#4C4339",
    "nameStrokeColorOver": "#4C4339",
    "nameStrokeWidth": 1.5,
    "nameStrokeOpacity": 0.5,
    
    "overDelay": 300,
    "nameAutoSize": false,
    
    "tooltipOnHighlightIn": false,
    "freezeTooltipOnClick": false,
    
    "mapId": "Z1BLIz2",
    
    "map_data": {
  "st1": {
   "name": "Alberta",
   "shortname": "AB",
   "comment": "<h3><strong>Laurie Tingley</strong></h3><p>laurietingley@t2.xyz</p><p>780 720 8093</p><p></p><h3><strong>Kat Tingley</strong></h3><p>kattingley@t2.xyz</p><p>780 902 7247</p>",
   "link": "",
   "color": "#4c4339",
   "colorOver": "#a1655e"
  },
  "st2": {
   "name": "British Columbia",
   "shortname": "BC",
   "comment": "<h2>Vancouver Island & Lower Mainland</h2><h3><strong>Greg Cook</strong></h3><p>greg@infocusinteriorsgroup.ca</p><p>604 619 3350</p><p></p><h3><strong>Tara Day</strong></h3><p>tara@sourcematerials.ca</p><p>604 377 8513</p></br><h2>Okanagan</h2><h3><strong>Kat Tingley</strong></h3><p>kattingley@t2.xyz</p><p>780 902 7247</p>",
   "link": "",
   "color": "#4c4339",
   "colorOver": "#a1655e"
  },
  "st3": {
   "name": "Manitoba",
   "shortname": "MB",
   "comment": "<h3><strong>Laurie Tingley</strong></h3><p>laurietingley@t2.xyz</p><p>780 720 8093</p><p></p><h3><strong>Kat Tingley</strong></h3><p>kattingley@t2.xyz</p><p>780 902 7247</p>",
   "link": "",
   "color": "#4c4339",
   "colorOver": "#a1655e"
  },
  "st4": {
   "name": "New Brunswick",
   "shortname": "NB",
   "comment": "<h3><strong>Polilam Sales</strong></h3><p><a href=\"mailto:Sales@polilam.com\">sales@polilam.com</a></p><p><a href=\"tel:4092182447\">409.218.2447</a></p>",
   "link": "",
   "color": "#4c4339",
   "colorOver": "#a1655e"
  },
  "st5": {
   "name": "Newfoundland and Labrador",
   "shortname": "NL",
   "comment": "<h3><strong>Polilam Sales</strong></h3><p><a href=\"mailto:Sales@polilam.com\">sales@polilam.com</a></p><p><a href=\"tel:4092182447\">409.218.2447</a></p>",
   "link": "",
   "color": "#4c4339",
   "colorOver": "#a1655e"
  },
  "st6": {
   "name": "Nova Scotia",
   "shortname": "NS",
   "comment": "<h3><strong>Polilam Sales</strong></h3><p><a href=\"mailto:Sales@polilam.com\">sales@polilam.com</a></p><p><a href=\"tel:4092182447\">409.218.2447</a></p>",
   "link": "",
   "color": "#4c4339",
   "colorOver": "#a1655e"
  },
  "st7": {
   "name": "Northwest Territories",
   "shortname": "NT",
   "comment": "<h3><strong>Polilam Sales</strong></h3><p><a href=\"mailto:Sales@polilam.com\">sales@polilam.com</a></p><p><a href=\"tel:4092182447\">409.218.2447</a></p>",
   "link": "",
   "color": "#4c4339",
   "colorOver": "#a1655e"
  },
  "st8": {
   "name": "Nunavut",
   "shortname": "NU",
   "comment": "<h3><strong>Polilam Sales</strong></h3><p><a href=\"mailto:Sales@polilam.com\">sales@polilam.com</a></p><p><a href=\"tel:4092182447\">409.218.2447</a></p>",
   "link": "",
   "color": "#4c4339",
   "colorOver": "#a1655e"
  },
  "st9": {
   "name": "Ontario",
   "shortname": "ON",
   "comment": "<h3><strong>Polilam Sales</strong></h3><p><a href=\"mailto:Sales@polilam.com\">sales@polilam.com</a></p><p><a href=\"tel:4092182447\">409.218.2447</a></p>",
   "link": "",
   "color": "#4c4339",
   "colorOver": "#a1655e"
  },
  "st10": {
   "name": "Prince Edward Island",
   "shortname": "PE",
   "comment": "<h3><strong>Polilam Sales</strong></h3><p><a href=\"mailto:Sales@polilam.com\">sales@polilam.com</a></p><p><a href=\"tel:4092182447\">409.218.2447</a></p>",
   "link": "",
   "color": "#4c4339",
   "colorOver": "#a1655e"
  },
  "st11": {
   "name": "Quebec",
   "shortname": "QC",
   "comment": "<h3><strong>Charles Briere</strong></h3><p>Print</p><p>charlesb@printinternational.ca</p><p>+1 855-296-2143</p>",
   "link": "",
   "color": "#4c4339",
   "colorOver": "#a1655e"
  },
  "st12": {
   "name": "Saskatchewan",
   "shortname": "SK",
   "comment": "<h3><strong>Laurie Tingley</strong></h3><p>laurietingley@t2.xyz</p><p>780 720 8093</p><p></p><h3><strong>Kat Tingley</strong></h3><p>kattingley@t2.xyz</p><p>780 902 7247</p>",
   "link": "",
   "color": "#4c4339",
   "colorOver": "#a1655e"
  },
  "st13": {
   "name": "Yukon",
   "shortname": "YT",
   "comment": "<h3><strong>Polilam Sales</strong></h3><p><a href=\"mailto:Sales@polilam.com\">sales@polilam.com</a></p><p><a href=\"tel:4092182447\">409.218.2447</a></p>",
   "link": "",
   "color": "#4c4339",
   "colorOver": "#a1655e"
  }
 },
 "points": {
 
 }
};